// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';

const renderInput = ({ input, label, type, meta: { touched, error } }) => {
  const handleChange = (e) => {
    const value = e.target.value.replace(/[^\p{L}\p{N} _-]/gu, '');
    input.onChange(value);
  };

  return (
    <div className="field_col">
      <label className="field_name" htmlFor="team-name-input">
        {label}
      </label>
      <input
        {...input}
        id="team-name-input"
        type={type}
        className="dashboard-input"
        placeholder="Type here..."
        maxLength={50}
        onChange={handleChange}
      />
      {touched && error ? <span className="error_text">{error}</span> : null}
    </div>
  );
};

const renderCheckboxList = ({ input, label, users }) => {
  const handleChange = (userId) => {
    const newValue = Array.isArray(input.value) ? [...input.value] : [];
    if (newValue.includes(userId)) {
      input.onChange(newValue.filter((v) => v !== userId));
    } else {
      input.onChange([...newValue, userId]);
    }
  };

  return (
    <div className="field_col">
      <span className="field_name">{label}</span>
      <div className="dashboard-modal-checkbox-list">
        {users.map((user) => (
          <label className="check_btn dashboard-check-label" key={user._id}>
            <input
              type="checkbox"
              name={`member_${user._id}`}
              checked={input.value?.includes(user.userId)}
              onChange={() => handleChange(user.userId)}
            />
            <span>{user.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

let AddOrEditTeamsReduxForm = ({ users, handleSubmit, closeModal, submitting }) => (
  <Form onSubmit={handleSubmit}>
    <div className="popup_body">
      <Field
        name="name"
        component={renderInput}
        type="text"
        label="Team name"
      />

      <Field
        name="members"
        component={renderCheckboxList}
        users={users}
        label="Members"
      />
    </div>

    <div className="popup_footer">
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        onClick={closeModal}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="dashboard-btn dashboard-btn--primary"
        aria-label="save"
        disabled={submitting}
      >
        Save
      </button>
    </div>
  </Form>
);

AddOrEditTeamsReduxForm = reduxForm({
  form: 'addOrEditTeamsReduxForm',
  enableReinitialize: true,
})(AddOrEditTeamsReduxForm);

export default withRouter(AddOrEditTeamsReduxForm);
